if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;
      // Manual mode: products are picked in theme settings and already rendered
      // server-side, so just initialise the slider — no fetch needed.
      if (this.dataset.manual === 'true') {
        this.initSlider();
        return;
      }
      // Try the configured intent first (complementary), then fall back to
      // Shopify's automatic "related" algorithm so the upsell is never empty.
      this.loadRecommendations(this.dataset.url, recommendations, true);
    }

    loadRecommendations(url, recommendations, allowFallback) {
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const fetched = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]');

          const hasItems =
            fetched && fetched.querySelector('.product-recommendations__item');

          if (!hasItems) {
            // No complementary products configured -> retry with related.
            if (allowFallback && url.indexOf('intent=complementary') !== -1) {
              this.loadRecommendations(
                url.replace('intent=complementary', 'intent=related'),
                recommendations,
                false
              );
            }
            return;
          }

          this.classList.remove('hidden');
          const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if (cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }
          recommendations.innerHTML = fetched.innerHTML;
          this.initSlider();
        });
    }

    initSlider() {
      if (typeof Swiper === 'undefined') {
        // Swiper not loaded yet (rare race on first paint); retry shortly.
        setTimeout(() => this.initSlider(), 100);
        return;
      }
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

/* One-click add-to-cart for upsell items, refreshing the cart drawer in place.
   Delegated so it keeps working after the drawer/recommendations re-render. */
if (!window.__upsellAddBound) {
  window.__upsellAddBound = true;

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button) return;

    // The item is wrapped in a link; never navigate when adding.
    event.preventDefault();
    event.stopPropagation();

    if (button.classList.contains('is--loading') || button.hasAttribute('disabled')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.classList.add('is--loading');

    const cart = document.querySelector('cart-drawer');

    let request;
    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(section => section.section).join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      request = fetch(`${routes.cart_add_url}`, config).then(response => response.json());
    } catch (error) {
      // Synchronous failure (e.g. a missing global) – never leave the spinner stuck.
      console.error(error);
      button.classList.remove('is--loading');
      return;
    }

    request
      .then(response => {
        // Shopify returns { status, message, description } on error.
        if (response.status || response.errors) {
          console.error(response.description || response.message || response.errors);
          return;
        }

        // Briefly confirm success before the drawer re-renders.
        button.classList.add('is--added');

        if (cart && typeof cart.renderContents === 'function' && response.sections) {
          // renderContents re-renders the drawer sections and re-opens it.
          cart.renderContents(response);
        }

        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      })
      .catch(error => console.error(error))
      .finally(() => button.classList.remove('is--loading'));
  });
}
